export const mediaBreakpoints = {
  md: 768,
  lg: 1200,
  xl: 1440,
};

export const getMediaBreakpoint = (bp: string) => {
  switch (bp) {
    case 'md':
      return mediaBreakpoints.md;
    case 'lg':
      return mediaBreakpoints.lg;
    case 'xl':
      return mediaBreakpoints.xl;
  }
};

export const mediaBP = (breakpoint: string) => {
  if (breakpoint === 'xs' && window.innerWidth < mediaBreakpoints.md) {
    return true;
  }
  if (window.innerWidth >= getMediaBreakpoint(breakpoint)) {
    return true;
  }
  return false;
};

export const isMediaBP = (breakpoint:string) => {
  if (window.innerWidth >= getMediaBreakpoint(breakpoint)) {
    return false;
  }
  return true;
};
